$(function() {

    $(".scroll-down-button").click(function() {            
        $('html, body').animate({
            scrollTop: $(".contact-info").offset().top
        }, 500);
    });
  
});